var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
export var DataSubProcessor;
(function (DataSubProcessor) {
    DataSubProcessor["KOMBO"] = "DATA_SUB_PROCESSOR_KOMBO";
})(DataSubProcessor || (DataSubProcessor = {}));
var DataSubProcessorConsent = /** @class */ (function (_super) {
    __extends(DataSubProcessorConsent, _super);
    function DataSubProcessorConsent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subProcessor = null;
        _this.isApproved = false;
        return _this;
    }
    return DataSubProcessorConsent;
}(Entity));
export { DataSubProcessorConsent };
